var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"background-color":"#fafafa"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"bottom"},[_c('div',{staticClass:"left"},[_vm._v(" 广东经纬招标代理有限公司 All Rights Reserved. ")]),_c('div',{staticClass:"right"},[_vm._v(" 粤ICP备2022139271号-1 ")])])])])
}]

export { render, staticRenderFns }